import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@sportninja/common/config/queryKeys'
import { fetchApiTokens } from '@sportninja/common/services/account'
import type { ApiToken } from '@sportninja/common/features/account/apiAccess'

/** The signed-in user's API tokens. Waits for the account to load. */
export const useApiTokens = (accountUid: string | undefined) =>
  useQuery<ApiToken[]>({
    queryKey: queryKeys.accountApiAccess.apiTokens(accountUid),
    queryFn: () => fetchApiTokens(accountUid as string),
    enabled: Boolean(accountUid),
  })
